import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 12,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Check localStorage for existing end time
    const storedEndTime = localStorage.getItem('handball_offer_end_time');
    let endTime: number;
    if (storedEndTime) {
      endTime = parseInt(storedEndTime, 10);
      // If time has passed, reset to 12 hours from now
      if (endTime < Date.now()) {
        endTime = Date.now() + 12 * 60 * 60 * 1000;
        localStorage.setItem('handball_offer_end_time', endTime.toString());
      }
    } else {
      // Set new end time to 12 hours from now
      endTime = Date.now() + 12 * 60 * 60 * 1000;
      localStorage.setItem('handball_offer_end_time', endTime.toString());
    }
    const updateTimer = () => {
      const now = Date.now();
      const difference = endTime - now;
      if (difference <= 0) {
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(difference % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 bg-blue-600 text-white py-2 px-4 shadow-md flex justify-center items-center gap-2 text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-88">
      <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-89" />
      <span data-id="element-90">La oferta termina en:</span>
      <div className="flex items-center gap-1 bg-blue-800 px-2 py-1 rounded" data-id="element-91">
        <span data-id="element-92">{formatTime(timeLeft.hours)}</span>
        <span data-id="element-93">:</span>
        <span data-id="element-94">{formatTime(timeLeft.minutes)}</span>
        <span data-id="element-95">:</span>
        <span data-id="element-96">{formatTime(timeLeft.seconds)}</span>
      </div>
    </div>;
}